/**
 * Better PathOfExile Trading — trade-site enhancements for pathofexile.com
 *
 * Declares one web-accessible-resource entry, the glob assets/images/* , but its matches
 * list is scoped to the pathofexile.com origins only — not every origin. So its resources
 * are genuinely unreachable from anywhere else, and only that site can detect it. We probe
 * the vendor-named assets/images/logo.png and the game-icon set beneath it.
 *
 * Manifest verified against version 1.9.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fhlinfpmdlijegjlpgedcmglkakaghnk';

export const betterPathofexileTrading: ExtensionDefinition = {
  id: ID,
  name: 'Better PathOfExile Trading',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.pathofexile.com',
  notes:
    'assets/images/* is scoped to the pathofexile.com origins, so only that site can ' +
    'detect it. A negative result from any other origin proves nothing.',
  signals: [
    {
      id: 'war-logo-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/logo.png — the extension logo, exposed only to the ' +
        'pathofexile.com origins.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/images/logo.png'),
    },
    {
      id: 'war-divine-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/bookmark-folder/divine.png — a bundled game-currency icon, a ' +
        'second origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/images/bookmark-folder/divine.png'),
    },
    {
      id: 'war-mirror-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/bookmark-folder/mirror.png — a third origin-scoped game icon, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/images/bookmark-folder/mirror.png'),
    },
  ],
};
